<div class="mass-assignment-container">
  <div class="top-hint-panel">
    <small class="range-hint">
      Присвоение диапазоны: 401-404<br>
      Номера: 401 402 403 404<br>
      Номера: 401,402,403,404
    </small>
  </div>

  <div class="form-section">
    <form [formGroup]="bibAssignForm">
      <div class="form-group mb-3">
        <input type="text" id="searchQuery" formControlName="searchQuery" class="form-control"
               [(ngModel)]="searchQuery" autofocus
               placeholder="Введите фамилию/имя/номер телефона/дистанцию">
      </div>
      <div class="form-group mb-3">
        <input type="text" id="bibNumbers" [(ngModel)]="bibsQuery" formControlName="bibNumbers" class="form-control"
               placeholder="Номера для присвоения" (keyup)="onBibKeyUp($event)">
      </div>
    </form>
  </div>

  <div class="table-container">
    <table class="styled-table">
      <thead>
      <tr>
        <th class="checkbox-column">
          <input type="checkbox" id="cb-select" class="custom-checkbox" (change)="toggleAllTeams($event)">
        </th>
        <th class="name-column">Клуб</th>
        <th class="name-column">Участники</th>
        <th class="name-column">Статус</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let team of teams | filterTeams: searchQuery;"
          [class.selected]="isTeamSelected(team)"
          (click)="toggleTeamSelection(team)">
        <td class="checkbox-column">
          <div class="custom-checkbox-wrapper">
            <input type="checkbox"
                   class="custom-checkbox"
                   [disabled]="team.areBibsAssigned"
                   (change)="toggleTeamSelection(team)"
                   [checked]="isTeamSelected(team)"
                   (click)="$event.stopPropagation()">
          </div>
        </td>
        <td class="name-column">{{ team.name }}
<!--          <p *ngIf="isTeamSelected(team)">{{getTeamCategory(team)}}</p>-->
        </td>
        <td class="name-column" style="text-align: center">{{ team.participants.length }}</td>
        <td class="status-column" style="text-align: center">
          <mat-icon *ngIf="team.areBibsAssigned" color="primary" style="color: green !important;">check_circle</mat-icon>
          <mat-icon *ngIf="!team.areBibsAssigned" color="accent">highlight_off</mat-icon>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="fixed-bottom-panel">
    <div class="panel-content">
      <div class="selected-info">
        <mat-icon class="info-icon">people</mat-icon>
        <span>{{ countTotalParticipants() }}</span>
      </div>
      <div class="button-container">
        <button class="button-main-blue"
                (click)="onSubmitTeams()"
                [disabled]="selectedTeams.length === 0">
          <mat-icon>assignment</mat-icon>
          Присвоить номера
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  /* Убираем скроллинг для всей страницы */
  :host ::ng-deep body {
    overflow: hidden;
  }

  /* Стили для чекбокса */
  .custom-checkbox {
    width: 20px;
    height: 20px;
    accent-color: #0d6efd;
    cursor: pointer;
  }

  .custom-checkbox-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  /* Фиксированные размеры для колонок */
  .checkbox-column {
    width: 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
    text-align: center;
  }

  .number-column {
    width: 60px;
    text-align: center;
  }

  .name-column {
    width: auto;
    text-align: left;
  }

  /* Мобильная версия */
  @media screen and (max-width: 576px) {
    .checkbox-column {
      width: 40px !important;
      min-width: 40px !important;
      max-width: 40px !important;
    }

    .number-column {
      width: 40px;
    }

    .custom-checkbox {
      width: 18px;
      height: 18px;
    }
  }
</style>
